import { useEffect, useState } from 'react';

interface VisualViewportMetrics {
  height: number;
  offsetTop: number;
}

export function calculateVisualViewportBottomInset(
  layoutHeight: number,
  viewport: VisualViewportMetrics,
): number {
  return Math.max(0, layoutHeight - viewport.height - viewport.offsetTop);
}

/** Track the layout-viewport area hidden below the visual viewport. */
export function useVisualViewportBottomInset(enabled: boolean): number {
  const [bottomInset, setBottomInset] = useState(0);

  useEffect(() => {
    if (!enabled || !window.visualViewport) {
      setBottomInset(0);
      return;
    }

    const viewport = window.visualViewport;
    const update = (): void => {
      setBottomInset(calculateVisualViewportBottomInset(window.innerHeight, viewport));
    };

    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [enabled]);

  return bottomInset;
}
